<button mat-icon-button [matMenuTriggerFor]="notificationsMenu" [matTooltip]="'mainNav.notificationsMenu.notificationsTooltip' | translate">
  <mat-icon *ngIf="notificationTotalCount > 0" [matBadge]="notificationTotalCount">notifications</mat-icon>
  <mat-icon *ngIf="notificationTotalCount == 0">notifications</mat-icon>
</button>
<mat-menu #notificationsMenu="matMenu" class="notification-menu" [xPosition]="'before'">
  <div class="notifications-container" (click)="$event.stopPropagation()">
    <div *ngIf="notifications.length == 0" class="noNotification mat-elevation-z4">
      {{'mainNav.notificationsMenu.noNotifications' | translate}}
    </div>

    <button *ngIf="notifications.length > 0" mat-raised-button class="mat-elevation-z4" color="primary" (click)="closeAllNotifications()">
      {{'mainNav.notificationsMenu.closeMyNotifications' | translate}}
    </button>

    <app-notification
      *ngFor="let notification of notifications"
      [notification]="notification"
      (notificationClosed)="onNotificationClosed($event)">
    </app-notification>

    <button *ngIf="isNotificationsLeft" mat-raised-button class="mat-elevation-z4" (click)="getNotifications()">
      {{ 'mainNav.notificationsMenu.more' | translate }}
    </button>
  </div>
</mat-menu>
